import React from 'react';

import FormLoader from '../shared/forms/FormLoader';
import PropTypes from 'prop-types';
import EditForm from './EditForm';

const MiscSaleEditor = ({
    editId,
    customerId,
    cancelEdit,
    fetchData
}) => {
    const getUrl = `/api/miscsales/edit/${editId}?customerId=${customerId}`;
    const postUrl = '/api/miscsales/edit';

    return (
        <FormLoader
            cancelEdit={cancelEdit}
            fetchData={fetchData}
            loadForm={editId !== undefined}
            getUrl={getUrl}
            postUrl={postUrl}
            validator={miscSaleValidator}
        >
            <EditForm
                cancelEdit={cancelEdit}
                miscSaleId={editId}
                //send fetchData so we can update jobs if 
                //we bypass the regular submit to add payments
                fetchData={fetchData}            />
        </FormLoader>
    );
}

MiscSaleEditor.propTypes = {
    editId: PropTypes.number,
    customerId: PropTypes.number,
    cancelEdit: PropTypes.func,
    fetchData: PropTypes.func
};

export default MiscSaleEditor;

const miscSaleValidator = (data) => {
    const details = [...data.miscSaleDetails];
    data.miscSaleDetails = details.filter(d => {
        if (d.description !== '' || d.amount !== '') {
            return d;
        }
    });

    let isValid = true;

    if (data.miscSaleDetails.length === 0) {
        isValid = false;
    }

    for (let i = 0; i < data.miscSaleDetails.length; i++) {
        let item = data.miscSaleDetails[i];

        if (item.description.length < 3) {
            item.description_error = 'Must be at least 3 characters';
            isValid = false;
        }
    }

    return isValid;
}